export let everythingSelected = "ep50Lb";
export default {everythingSelected};